import React from 'react';
import '../UploadForm.css';

function SubmitButton({ isLoading, progress = 0, disabled, type = 'submit' }) {
  return (
    <button
      type={type}
      disabled={disabled}
      className={`submit-resume-button ${progress === 100 ? 'completed' : ''}`}
      style={{ '--progress': `${progress}%` }}
      aria-busy={isLoading || undefined}
      aria-live="polite"
      aria-label={isLoading ? `Processing ${progress}%` : 'Submit resumes for processing'}
    >
      <span className={isLoading ? 'processing-text' : 'Submit'}>
        {isLoading ? 'Processing...' : 'Submit'}
      </span>
    </button>
  );
}

export default SubmitButton;


